import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getInspectionsByCompany, InspectionReportByCompany } from '@/services/dashboardService';
import { getCurrentMonth } from '@/utils/date';

import { DataStatus } from './dataStatus';
import { LoadingSpinner } from './LoadingSpinner';
import MonthSelector from './MonthSelector';
import './dashboard.css';
import chartColors from './chartColors';

const ChartInspectionsByCompany = () => {
    const {year: currentYear, month: currentMonth} = getCurrentMonth();

    const [companyNames, setCompanyNames] = useState<string[]>([]);
    const [companyInspections, setCompanyInspections] = useState<number[]>([]);
    const [dataStatus, setDataStatus] = useState<DataStatus>(DataStatus.LOADING);
    const [month, setMonth] = useState<number>(currentMonth);
    const [year, setYear] = useState<number>(currentYear);

    const getData = async (month: number, year: number) => {
        setDataStatus(DataStatus.LOADING)
        const response = await getInspectionsByCompany(month, year);
        if (!response.data){
            setDataStatus(DataStatus.ERROR);
            return;
        }
        if (response.data.length === 0){
            setDataStatus(DataStatus.EMPTY);
            return;
        }
        const originalData = response.data as InspectionReportByCompany[];
        const transformedData = transformData(originalData);
        setCompanyNames(transformedData.companies);
        setCompanyInspections(transformedData.inspections);
        setDataStatus(DataStatus.OK);
    };

    const transformData = (originalData: InspectionReportByCompany[]) => {
        const companies: string[] = [];
        const inspections: number[] = [];
        originalData.map((company) => {
            companies.push(company.companyName);
            inspections.push(company.totalInspection);
        });
        return { companies, inspections };
    };

    useEffect(() => {
        getData(currentMonth, currentYear);
    }, []);

    useEffect(() => {
        getData(month, year);
    }, [month, year]);

    const series = [{
        name: 'Total Inspections',
        data: companyInspections,
    }];

    const chartOptions: ApexCharts.ApexOptions = {
        chart: {
            type: 'bar',
        },
        plotOptions: {
            bar: {
                horizontal: false,
                dataLabels: {
                    position: 'top'
                },
            },
        },
        series,
        xaxis: {
            categories: companyNames,
        },
        colors: [chartColors.red],
    };

    return (
        <div className='card card-bar'>
            <h2 className='card-title'>Inspections by Company</h2>
            <div>
                <MonthSelector month={month} year={year} onChange={(selectedMonth, selectedYear) => { setMonth(selectedMonth); setYear(selectedYear) }} />
                {(dataStatus === DataStatus.LOADING) && <LoadingSpinner />}
            </div>
            
            {(dataStatus === DataStatus.EMPTY || dataStatus === DataStatus.ERROR) && <div>No data to display</div>}
            {(dataStatus === DataStatus.OK || dataStatus === DataStatus.LOADING) && <ReactApexChart type="bar" options={chartOptions} series={series} height={600} />}
        </div>
    );
};

export default ChartInspectionsByCompany;
